import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  createDateColumnHeader: {
    defaultMessage: 'Created at',
    id: 'iuLRct',
    description: 'Purchase Created at Column Header',
  },
  orderDateColumnHeader: {
    defaultMessage: 'Order Date',
    id: '0u4hkk',
    description: 'Purchase Order Date Column Header',
  },
  expectedDeliveryDateColumnHeader: {
    defaultMessage: 'Expected Delivery',
    id: 'p/DxL9',
    description: 'Purchase Order Expected Delivery Date Column Header',
  },
  purchaseOrderNumberColumnHeader: {
    defaultMessage: 'Order ID',
    id: 'WzmebV',
    description: 'Purchase Order Number Column Header',
  },
  referenceNumberColumnHeader: {
    defaultMessage: 'Reference Number',
    id: 'Yp/+ZJ',
    description: 'Reference Number Column Header',
  },
  supplierNameColumnHeader: {
    defaultMessage: 'Supplier Name',
    id: 'ytdCcu',
    description: 'Supplier Name Column Header',
  },
  statusColumnHeader: {
    defaultMessage: 'Status',
    id: 'VvJw+A',
    description: 'Status Column Header',
  },
  receiveInventoryHeader: {
    defaultMessage: 'Receive Stock',
    id: '0R5hNo',
    description: 'Receive Stock Header',
  },
  receiveInventoryButton: {
    defaultMessage: 'Receive',
    id: 'OiP2Ln',
    description: 'Receive Inventory Button',
  },
  gridPlaseholderTitle: {
    description: 'Purchase Orders Placeholder Title',
    defaultMessage: 'You have no <b>Purchase Orders</b> to view',
    id: 'mQmBu2',
  },
  gridPlaceholderDescription: {
    description: 'Purchase Orders Placeholder Description',
    defaultMessage: 'No Purchase Orders data to view at the moment',
    id: 'EkjFqa',
  },
  warehouseColumnHeader: {
    defaultMessage: 'Warehouse',
    id: '5DggPN',
    description: 'Warehouse Column Header',
  },
});
